import React from "react";
import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Type } from "../actions/types";
import { PUBLIC_URL } from "../serviceWorker";

interface Props {
  productType: Type;
}

export default class ProductType extends React.Component<Props> {
  render() {
    const { productType } = this.props;
    return (
      <Link to={"/product-type/" + productType.id}>
        <Card border="light" style={{ backgroundColor: "rgb(0,0,0,0.6)" }}>
          <Card.Img
            style={{ filter: "brightness(0.4)", maxHeight: "450px" }}
            src={productType.path ? PUBLIC_URL + productType.path : ""}
          />
          <div
            className={
              productType.path
                ? "card-img-overlay d-flex align-items-end justify-content-center mb-5"
                : "d-flex align-items-end justify-content-center mb-3"
            }
          >
            <h1 className={"text-white text-uppercase"}>{productType.name}</h1>
          </div>
        </Card>
      </Link>
    );
  }
}
